// extracted by mini-css-extract-plugin
export default {"Home_Container":"home_Home_Container__l3P-7"};